import React, { useState, useEffect, useContext } from "react";
import Pusher from "pusher-js";
import { makeStyles } from "@mui/styles";
import {
  Dialog,
} from "@mui/material";
import { userInfoContext } from "../../context/userInfoContext";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import * as Routes from "../../Routes";
import {
  CloseIconWrapper,
  Icon,
  IconCard,
  IconWrapper,
  Logo,
  LogoWrapper,
  MenuIconWrapper,
  MobileIcon,
  MobileIconWrapper,
  MobileLogoWrapper,
  MobileView,
  Root,
  Text,
  TextWraper,
  } from "../StyledComponents/MenuListStyledComponents";
  import { WalletDetailsPopup } from "../WalletComponents/WalletDetailsPopup";
  import { Modal } from "@mui/material";
  import styled from "styled-components";
  import { init, balanceOf, getBalance } from "../../config/provider";
  import { ethers } from "ethers";
  import axios from "axios";
  import environmentVariables from "../../config/environmentVariables";
  import { userBalanceContext } from "../../context/userBalanceContext";
  import { buyTokenPopUpContext } from "../../context/buyTokenPopUpContext";
import { toast } from "react-toastify";
  const MALogo =   `${environmentVariables?.cdnUrl}ms-logo.png`
  const HomeIcon = `${environmentVariables?.cdnUrl}home.png`
  const FarmIcon = `${environmentVariables?.cdnUrl}farm.png`
  const PoolIcon = `${environmentVariables?.cdnUrl}pool.png`
  const NftMarketing = `${environmentVariables?.cdnUrl}nft-marketing.png`;
  const Wallet = `${environmentVariables?.cdnUrl}wallet.png`;
  
const useStyles = makeStyles((theme) => ({
  customButton: {
    padding: "30px",
    backgroundColor: "#2a2a2a",
    border: "1px solid #484848",
    borderRadius: "10px",
    color: "#fff",
    minWidth: "300px",
    "@media (max-width: 768px)": {
      minWidth: "360px",
    },
    "@media (max-width: 600px)": {
      maxWidth: "220px",
      minWidth: "350px",
      padding: "40px 30px",
      backgroundColortransparent: true,
    },
  },
}));

const ProfileIcon = styled.div`
  font-size: 30px;
`;
const Span = styled.span`
  padding: 0 10px;
`;
const ButtonCancel = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -15px;
  right: -20px;
  background-color: #b3b3b3;
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 20px;
  /* font-weight: 600; */
  padding: 20px;
  margin: 0;
  cursor: pointer;
  color: #000;
  width: 45px;
  height: 45px;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
    top: -25px;
    right: -15px;
  }
  @media (max-width: 600px) {
    top: -30px;
    right: 85px;
  }
  /* &:hover {
    background: linear-gradient(45deg, #fff, #d3d3d3);
    color: #151a1c;
  } */
`;
const NftNameConfirm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
  padding-top: 20px;
  border-bottom: 1px solid #484848;
  border-top: 1px solid #484848;
  justify-content: center;
  ${(p) => {
    p.ConfirmPopup &&
      `
   justify-content: flex-start;
  `;
  }}
`;
const NftNameConfirmHead = styled.div`
  font-size: 32px;
  font-weight: 500;
  // text-align: center;
`;
const BuyPop = styled.div`
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 16px;
  font-weight: 600;
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #c95e73;
  text-transform: capitalize;
  background-color: #171e22;
  padding: 25px 20px;
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  margin-left: 10px;
  border: 1px solid #31393c;
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 35px;
  width: 170px;
  margin-top: 20px;
  cursor: pointer;
  &:hover {
  }
`;
const NftNameConfirmSubHead = styled.div`
  font-size: 16px;
  color: #bbb;
  text-transform: capitalize;
  padding-top: 10px;
  padding-bottom: 15px;
`;
const DropDownSection = styled.div`
  position: absolute;
  left: 70px;
  box-shadow: none;
  top: 45px;
  width: 100%;
  cursor: pointer;
  color: #fff;
  /* @media (max-width: 768px) {
    position: relative;
    left: -70px;
    background: none;
    box-shadow: none;
    top: 25px;
    width: 100%;
    cursor: pointer;
  } */
  /* @media (max-width: 1024px) {
    position: relative;
    left: -70px;
    background: none;
    box-shadow: none;
    top: 25px;
    width: 100%;
    cursor: pointer;
  } */
`;

const List = styled.div`
  font-size: 15px;
  height: 45px;
  display: flex;
  align-items: center;
  padding: 20px;

  @media (max-width: 768px) {
    color: #d5cdcd;
    padding: 0;
    height: 35px;
    margin: 20px 0;
  }
  @media (max-width: 1024px) {
    color: #d5cdcd;
    padding: 0;
    height: 35px;
    margin: 20px 0;
  }
`;
const DialogStyledUpdate = styled(Dialog)``;
const LeftsideBar = ({
  callFun,
  showNavigation,
  setShowNavigation,
  allContractDetails,
  setAllContractDetails,
  show,
  setShow,
}) => {

  const classes=useStyles();
  let navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const { isBuyOpen } = useContext(buyTokenPopUpContext);
  const {userAccInfo, setUserAccInfo}=useContext(userInfoContext)
  const [buyTokenLoginPopUp,setBuyTokenLoginPopUp]=useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [navLink, setNavLink] = useState(location.pathname);
  const [dropdown, setDropdown] = useState(false);

  const { userBalance, setUserBalance } = useContext(userBalanceContext);

  const setUserToken=(res)=>{
    if(res?.idToken){
      let data={
        userName:res?.userInfo?.email||res?.userInfo?.name||res?.userInfo?.verifierId||'metamask',
        address:res?.address
      }
      let config={
        method:"post",
        url:`${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get/token`,
        headers:{
          authorization:`Bearer ${res?.idToken}`
        },
        data:data
      }
      axios.request(config).then(respnse=>{
        console.log(respnse,';;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;s')
      }).catch( err=>{
        console.log(err);
        localStorage.clear();
      allContractDetails?.logout();
      setAllContractDetails(null);
      setUserBalance({
        MLDBalance: 0,
        LORDBalance: 0,
        MLD: 0,
        LORD: 0,
        MATICBalance: 0,
        MATIC: 0,
      });
        // toast.error(err?.response?.data?.message||err?.message)
      })
    }else{
      toast.error("id token is required")
    }

  }


  const handleLogin=()=>{
    try{
      init().then(res=>{
        setAllContractDetails(res);
        setUserToken(res)
        // console.log(res,';;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;')
        setBuyTokenLoginPopUp(false)
        handleOpen();
      }).catch(err=>{
        console.log(err)  
      })
    }catch(err){
      console.log(err);
    }
  }

  const setDataOfContract = async () => {
    const address = allContractDetails?.address;

    const mldBal = await balanceOf(
      allContractDetails?.mldTokenContract,
      address
    );
    const lordBal = await balanceOf(
      allContractDetails?.lordTokenContract,
      address
    );
    const usdtBal = await balanceOf(
      allContractDetails?.usdtTokenContract,
      address
    );
    const maticBal = await getBalance(allContractDetails?.provider, address);

    // setUserBalance({
    //   MLDBalance: parseInt(mldBal),
    //   LORDBalance: parseInt(lordBal),
    //   USDTBalance: parseInt(usdtBal),
    //   MLD: ethers.utils.formatEther(mldBal),
    //   LORD: ethers.utils.formatEther(lordBal),
    //   MATICBalance: parseInt(maticBal),
    //   MATIC: ethers.utils.formatEther(maticBal),
    //   USDT: ethers.utils.formatEther(usdtBal),
    // });
  };
  useEffect(() => {
    if (isBuyOpen) {
      handleOpen();
    }
  }, [isBuyOpen]);
  useEffect(() => {
    if (callFun) {
      setDataOfContract();
    }
  }, [callFun]);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const action = params.get("action");
    // const token=params.get("token");
    // console.log(action,token,'//////////////////////////////////////////////////////////////////');
    if (action == "buy") {
      // setOpen(true)
      localStorage.clear();
      allContractDetails?.logout();
      setBuyTokenLoginPopUp(true);
    }
  }, []);
  useEffect(() => {
    if (allContractDetails && allContractDetails?.address) {
      setDataOfContract();
      getUserBalance(allContractDetails?.address);
    }
  }, [allContractDetails]);
  useEffect(() => {
    Pusher.logToConsole = true;
    const pusher = new Pusher("cbb68a6fad0862e7fd60", {
      cluster: "ap2",
    });
    const channel = pusher.subscribe("notification-show");
    channel.bind("my-event", (data) => {
      if (allContractDetails) {
        getUserBalance(allContractDetails?.address);
      }
    });
  }, [allContractDetails]);
  // useEffect(() => {
  //   if (allContractDetails) {
  //     socket.emit("join_room", allContractDetails?.address);
  //     socket.on("receive_mld", async (data) => {
  //       // Swal.fire(
  //       //   `Received ${data?.currency}`,
  //       //   `Received ${data?.amount} ${data?.currency} from ${data?.from}`,
  //       //   "success"
  //       // );
  //       getUserBalance(allContractDetails?.address);
  //     });
  //   }
  // }, [socket, allContractDetails]);

  // const connectWallet = async () => {
  //   init().then(async (data) => {
  //     setAllContractDetails(data)
  //     const address = data.address;

  //     const mldBal = await balanceOf(data.mldTokenContract, address)
  //     const lordBal = await balanceOf(data.lordTokenContract, address)
  //     const maticBal = await getBalance(data.provider, address)

  //     setUserBalance({
  //       MLDBalance: parseInt(mldBal),
  //       LORDBalance: parseInt(lordBal),
  //       MLD: ethers.utils.formatEther(mldBal),
  //       LORD: ethers.utils.formatEther(lordBal),
  //       MATICBalance: parseInt(maticBal),
  //       MATIC: ethers.utils.formatEther(maticBal),
  //     })
  //   }).catch((err) => {
  //     console.log('err', err)
  //   })
  // }
  // const logoutWallet = async () => {
  //   await allContractDetails?.logout().then(async (data) => {
  //     console.log('logout data', data)
  //     clearData()
  //     setAllContractDetails({})
  //   }).catch((err) => {
  //     console.log('err', err)
  //   })
  // }
  const getUserBalance = (address) => {
    axios
      .get(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/getuserbalance/${address}`,
        {headers:{authorization:`Bearer ${userAccInfo}`}}
      )
      .then((res) => {
        // console.log(res.data.data);
        setUserBalance(res.data.data);
      })
      .catch((err) => console.log(err));
  };
  // const clearData = () => {
  //   setUserBalance({
  //     MLDBalance: 0,
  //     LORDBalance: 0,
  //     MLD: 0,
  //     LORD: 0,
  //     MATICBalance: 0,
  //     MATIC: 0,
  //   });
  // };
  const getInformation = async (data) => {
    await clearData();

    const address = data.address;

    const mldBal = await balanceOf(data.mldTokenContract, address);
    const lordBal = await balanceOf(data.lordTokenContract, address);
    const maticBal = await getBalance(data.provider, address);
    const usdtBal = await balanceOf(data.usdtTokenContract, address);
    setUserBalance({
      MLDBalance: parseInt(mldBal),
      LORDBalance: parseInt(lordBal),
      USDTBalance: parseInt(usdtBal),
      MLD: ethers.utils.formatEther(mldBal),
      LORD: ethers.utils.formatEther(lordBal),
      USDT: ethers.utils.formatEther(usdtBal),
      MATICBalance: parseInt(maticBal),
      MATIC: ethers.utils.formatEther(maticBal),
    });
  };
  return (
    <>
      {
        <MenuIconWrapper
          onClick={(e) => {
            e.stopPropagation();
            setShowNavigation(!showNavigation);
          }}
          style={{ zIndex: "9" }}
        >
          <i class="fa-solid fa-bars"></i>
        </MenuIconWrapper>
      }
      <Root>
        <LogoWrapper
          onClick={() => {
            navigate("/");
          }}
        >
          <Logo
            src={MALogo}
            width="60px"
            height="56px"
            top="sm"
            bottom="sm"
            cursor="pointer"
          />
        </LogoWrapper>

        <IconCard wallett onClick={handleOpen}>
          <IconWrapper>
            <ProfileIcon>
              <Icon src={Wallet} width="24px" height="24px" />
            </ProfileIcon>
          </IconWrapper>
          <Text wallettext>Wallet</Text>
        </IconCard>

        <IconCard
          selected={location.pathname === "/"}
          top="xs"
          bottom="xxs"
          onClick={() => {
            navigate("/");
            setNavLink("/");
          }}
        >
          <IconWrapper>
            <Icon src={HomeIcon} width="20px" height="20px" />
          </IconWrapper>
          <Text>Dashboard</Text>
        </IconCard>

        <IconCard
          selected={
            location.pathname === "/nftMarket" ||
            location.pathname === "/trendingnfts" ||
            location.pathname === "/auctionnfts" ||
            location.pathname === "/mynfts" ||
            location.pathname ===
              "/nftcategories/0x8fc3dec6148a9924870f205617c9c26b3010243e"
          }
          onClick={() => {
            navigate(`${Routes.NFTMARKET}`);
            setNavLink("/nftMarket");
          }}
        >
          <IconWrapper>
            <Icon src={NftMarketing} width="24px" height="20px" />
          </IconWrapper>
          <Text>Marketplace</Text>
        </IconCard>
        <IconCard
          selected={location.pathname === "/pool"}
          onClick={() => {
            navigate(`${Routes.POOL}`);
            setNavLink("/pool");
          }}
        >
          <IconWrapper>
            <Icon src={PoolIcon} width="24px" height="24px" />
          </IconWrapper>
          <Text>Pool</Text>
        </IconCard>
        <IconCard
          selected={location.pathname === "/stake"}
          onClick={() => {
            navigate(`${Routes.FARM}`);
            setNavLink("/stake");
          }}
        >
          <IconWrapper>
            <Icon src={FarmIcon} width="22px" height="22px" />
          </IconWrapper>
          <Text>Stake</Text>
        </IconCard>
        {/* <IconCard  selected={location.pathname === '/metaDao'} 
      onClick={() => {
          navigate(`${Routes.METADAO}`);
          setNavLink('/metaDao');
        }}>
        <IconWrapper>
          <Icon src={MetaDaoIcon} width="24px" height="20px" />
        </IconWrapper>
        <Text>MetaDAO</Text>
      </IconCard> */}
        {/* <IconCard selected={location.pathname === '/stats'} onClick={() => {
          navigate(`${Routes.STATS}`);
          setNavLink('/stats');
        }}>
        <IconWrapper>
          <Icon src={StatsIcon} width="24px" height="24px" />
        </IconWrapper>
        <Text> Stats </Text>
      </IconCard> */}

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <WalletDetailsPopup
            getInformation={getInformation}
            setOpen={setOpen}
            userBalance={userBalance}
            getUserBalance={getUserBalance}
            allContractDetails={allContractDetails}
            setAllContractDetails={setAllContractDetails}
            showNavigation={showNavigation}
            setShowNavigation={setShowNavigation}
            handleClose={handleClose}
          />
        </Modal>
      </Root>
      {showNavigation && (
        <MobileView onClick={(e) => e.stopPropagation()}>
          <CloseIconWrapper
            onClick={() => {
              setShowNavigation(!showNavigation);
            }}
          >
            <i class="fa-solid fa-xmark"></i>
          </CloseIconWrapper>
          <MobileLogoWrapper
            selected={location.pathname === "/"}
            onClick={() => {
              navigate("/");
            }}
          >
            <Logo
              src={MALogo}
              width="60px"
              height="56px"
              top="sm"
              bottom="sm"
              cursor="pointer"
            />
          </MobileLogoWrapper>

          <IconCard wallett onClick={handleOpen}>
            <IconWrapper>
              <ProfileIcon>
                <Icon src={Wallet} width="24px" height="24px" />
              </ProfileIcon>
            </IconWrapper>
            <Text wallettext>Wallet</Text>
          </IconCard>

          <MobileIconWrapper
            selected={location.pathname === "/"}
            onClick={() => {
              navigate(`${Routes.HOME}`);
              setNavLink("/");
              setShowNavigation(!showNavigation);
            }}
          >
            <MobileIcon src={HomeIcon} width="22px" height="22px" />
            <TextWraper> Dashboard </TextWraper>
          </MobileIconWrapper>
          <MobileIconWrapper
            selected={location.pathname === "/pool"}
            onClick={() => {
              navigate(`${Routes.POOL}`);
              setNavLink("/");
              setShowNavigation(!showNavigation);
            }}
          >
            <MobileIcon src={PoolIcon} width="26px" height="26px" />{" "}
            <TextWraper>Pool</TextWraper>
          </MobileIconWrapper>
          <MobileIconWrapper
            selected={location.pathname === "/stake"}
            onClick={() => {
              navigate(`${Routes.FARM}`);
              setNavLink("/stake");
              setShowNavigation(!showNavigation);
            }}
          >
            <MobileIcon src={FarmIcon} width="22px" height="22px" />
            <TextWraper>Stake</TextWraper>
          </MobileIconWrapper>
          <MobileIconWrapper
            selected={location.pathname === "/nftMarket"}
            onClick={(e) => {
              e.stopPropagation();
              setDropdown(!dropdown);
            }}
          >
            <Icon src={NftMarketing} width="24px" height="20px" />
            <>
              <TextWraper>Market</TextWraper>
              <Span>
                <i class="fa-solid fa-angle-down"></i>
              </Span>
            </>
            {dropdown && (
              <>
                <DropDownSection>
                  <List
                    onClick={() => {
                      navigate("/nftMarket");
                      setDropdown(!dropdown);
                      setShowNavigation(!showNavigation);
                    }}
                  >
                    Home
                  </List>
                  <List
                    onClick={() => {
                      navigate(
                        "/nftcategories/0x7eb272ac9b9fec60c5a7921ccc075152a961111c"
                      );
                      setDropdown(!dropdown);
                      setShowNavigation(!showNavigation);
                    }}
                  >
                    Character
                  </List>
                  <List
                    onClick={() => {
                      navigate(
                        "/nftcategories/0x8fc3dec6148a9924870f205617c9c26b3010243e"
                      );
                      setDropdown(!dropdown);
                      setShowNavigation(!showNavigation);
                    }}
                  >
                    Shootable
                  </List>
                  <List
                    onClick={() => {
                      navigate(
                        "/nftcategories/0x6ab30d4c7de4a24cbe84eb310fd164b64b06b532"
                      );
                      setDropdown(!dropdown);
                      setShowNavigation(!showNavigation);
                    }}
                  >
                    Melee
                  </List>
                  {/* <List
                    onClick={() => {
                      navigate("/auctionnfts");
                      setDropdown(!dropdown);
                      setShowNavigation(!showNavigation);
                    }}
                  >
                   Characters
                  </List> */}
                  {/* <List
                    onClick={() => {
                      navigate("/auctionnfts");
                      setDropdown(!dropdown);
                      setShowNavigation(!showNavigation);
                    }}
                  >
                   Vehicles 
                  </List> */}
                  {/* <List
                    onClick={() => {
                      navigate("/auctionnfts");
                      setDropdown(!dropdown);
                      setShowNavigation(!showNavigation);
                    }}
                  >
                   Auctions 
                  </List> */}
                  {allContractDetails?.address && (
                    <List
                      onClick={() => {
                        navigate("/mynfts");
                        setDropdown(!dropdown);
                        setShowNavigation(!showNavigation);
                      }}
                    >
                      My NFT's
                    </List>
                  )}
                </DropDownSection>
              </>
            )}
          </MobileIconWrapper>

          {/* <MobileIconWrapper selected={location.pathname === '/metaDao'} 
       onClick={() => {
        navigate(`${Routes.METADAO}`);
        setNavLink('/metaDao');
        setShowNavigation(!showNavigation);
      }}>
      <MobileIcon src={MetaDaoIcon} width="24px" height="20px" /> <TextWraper>MetaDAO</TextWraper>
      </MobileIconWrapper> */}
          {/* <MobileIconWrapper selected={location.pathname === '/stats'} 
       onClick={() => {
        navigate(`${Routes.STATS}`);
        setNavLink('/stats');
        setShowNavigation(!showNavigation);
      }}>
      <MobileIcon src={StatsIcon} width="24px" height="24px" /><TextWraper>Stats</TextWraper>
      </MobileIconWrapper> */}
        </MobileView>
      )}
      <DialogStyledUpdate
        open={buyTokenLoginPopUp}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: { overflow: "initial", backgroundColor: "transparent" },
        }}
      >
        {/* <ButtonCancel color="primary">X</ButtonCancel> */}
        <div className={classes.customButton}>
          <NftNameConfirm>
            <NftNameConfirmHead>
             Please Login to Continue
            </NftNameConfirmHead>
            <NftNameConfirmSubHead>
            Please login with same Email Id & provider to keep your assets synced!
            </NftNameConfirmSubHead>
            <BuyPop onClick={()=>handleLogin()}>Login</BuyPop>
          </NftNameConfirm>
        </div>
      </DialogStyledUpdate>
    </>
  );
};

export default LeftsideBar;
